import React, { createContext, useContext } from "react";
import type { AdminIdentity, TokenSet } from "./types";

export type AdminContextValue = Readonly<{
  identity: AdminIdentity;
  tokens: TokenSet | null;
  navigate: (path: string) => void;
  refreshNonce: number;
  refresh: () => void;
}>;

export const AdminContext = createContext<AdminContextValue | null>(null);
export function useAdminContext(): AdminContextValue {
  const value = useContext(AdminContext);
  if (!value) throw new Error("admin_context_missing");
  return value;
}
